module.exports = __webpack_public_path__ + "img/FP (3).5718156f.jpeg";